export default {
  primary: {
    main: "#216C2A",
    light: "#278032",
  }
}
